import { render, staticRenderFns } from "./DialogConfiguracoes.vue?vue&type=template&id=36f880bd&scoped=true"
import script from "./DialogConfiguracoes.vue?vue&type=script&lang=js"
export * from "./DialogConfiguracoes.vue?vue&type=script&lang=js"
import style0 from "./DialogConfiguracoes.vue?vue&type=style&index=0&id=36f880bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f880bd",
  null
  
)

export default component.exports